import { xs_languageCode } from "..";
import { getUrlPathSeoSettings } from "./utils/getUrlPathSeoSettings";
import { getUrlPathSeo } from "./utils/getUrlPathSeo";
import { parseBetsData } from "./parseBetsData";
import { filterByCustomizedState } from './utils/filterByCustomizedState';
import { formatDate } from './utils/formatDate';
import { formatDateWithWeekDay } from './utils/formatDateWithWeekDay';
import { getLiveAggs } from './utils/getLiveAggs';
import { getPrematchAggs } from './utils/getPrematchAggs';
import { getSplitDesc } from './utils/getSplitDesc';
import { getUrlPath } from "./util/getUrlPath";

export function parseAutocompleteData(data, isLive) {
    const matches = filterByCustomizedState(data.ms);

    const result = [];
    matches.forEach(function(m) {
        const desc = m.dsl[xs_languageCode];
        const sportDesc = m.dsml[xs_languageCode];
        const tournamentDesc = m.dtml[xs_languageCode];
        const [team1, team2] = getSplitDesc(desc);

        const formattedDate = formatDateWithWeekDay(m.ts);
        const date = formattedDate.dayMonthYear;
        const dateShort = formattedDate.dayMonthShort;
        const time = formatDate(m.ts).time;
        const sportPath = sportDesc.replace(/\s+/g, '-').toLocaleLowerCase();
        const tournamentPath = `${sportPath}/${tournamentDesc.replace(/\s+/g, '-').toLocaleLowerCase()}`;
        const tournamentUniqueId = `${m.s}_${m.c}_${m.t}`;

        const bets = m.sc ? [m.sc] : [];

        let match = {
            alias: m.al,
            avv: m.a,
            categoryDesc: m.dcml[xs_languageCode],
            categoryRef: m.c,
            date,
            dateShort,
            desc,
            id: m.bid,
            isLive,
            openAggregata: m.ag,
            openMacrogruppo: m.mc,
            pal: m.p,
            plus: m.nsc,
            sportDesc: sportDesc,
            sportRef: m.s,
            sportUrlPath: sportPath,
            sportUrlPathSuffix: `_${m.s}`,
            team1,
            team2,
            time,
            timestampDB: m.ts,
            tournamentDesc: tournamentDesc,
            tournamentRef: m.t,
            tournamentUrlPath: tournamentPath,
            tournamentUrlPathSeo: getUrlPathSeo({seoSettings: m.tournamentSeo}),
            tournamentUrlPathSeoSettings: getUrlPathSeoSettings({seoSettingsAdds: m.tournamentSeoa}),
            tournamentUrlPathSuffix: `_${tournamentUniqueId}`,
            uniqueId: `${tournamentUniqueId}_${m.bid}`,
            urlPath: getUrlPath({uniqueId: `${m.s}_${m.c}_${m.t}`, urlPath: tournamentPath}, m, desc),
            urlPathSeo: getUrlPathSeo({seoSettings: m.seo}),
            urlPathSeoSettings: getUrlPathSeoSettings({seoSettingsAdds: m.seoa})
        };

        const agg = isLive ? getLiveAggs(m.s, m.ag) : getPrematchAggs(m.s, m.ag);
        const betData = parseBetsData(match, [agg.idAggregata], agg.idAggregata, bets, isLive, true);
        match = Object.assign({},match, betData); //Assign betData directly to the match object leads to JSON circularity issues, so we use an empty JSON object as target

        if (match.bets?.[0]?.hasOdds ?? false) {
            result.push(match);
        }
    });

    return result;
}
